// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const fuecoco: PokeData = {
  "id": 909,
  "name": "fuecoco",
  "height": 4,
  "weight": 98,
  "base_experience": 62,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "tackle",
    "leer",
    "bite",
    "roar",
    "ember",
    "flamethrower",
    "fire-blast",
    "yawn",
    "hyper-voice",
    "round",
    "incinerate",
    "snarl"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "ember",
    "flamethrower",
    "hyper-voice",
    "snarl",
    "morning-sun",
    "fire-spin",
    "eruption",
    "fire-ball",
    "magma-storm",
    "fire-fang"
  ],
  "evolution_chain": {
    "id": 479,
    "item": null,
    "species": [
      {
        "name": "fuecoco",
        "order": 909,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "crocalor",
        "order": 910,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 909,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "skeledirge",
        "order": 911,
        "types": [
          PokeType.FIRE,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 910,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 58.25,
    "speed": 36,
    "ability_power": 63
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
